import { useState, useCallback } from "react";

/**
 * Simple form state hook. Exposes email/password/name state, submitting flag,
 * error message and a `handleSubmit(action)` wrapper that runs the passed action
 * and captures errors.
 */
export function useAuthForm() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = useCallback(async (action) => {
    setErrorMsg("");
    setSubmitting(true);
    try {
      await action({ email, password, name });
    } catch (e) {
      const detail = e?.response?.data?.detail;
      const msg = typeof detail === "string" ? detail : (e?.message || "Something went wrong");
      setErrorMsg(msg);
    } finally {
      setSubmitting(false);
    }
  }, [email, password, name]);

  const clearError = useCallback(() => setErrorMsg(""), []);

  return {
    email, setEmail,
    password, setPassword,
    name, setName,
    errorMsg, setErrorMsg, clearError,
    submitting,
    handleSubmit,
  };
}
